import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { MailIcon, GoogleIcon, OfficeIcon } from 'components/icon'

import styles from './DPC_secondary_button.scss'

class DPC_SecondaryButton extends Component {

	render() {
		let Icon = () => null

		if (this.props.icon) {
			Icon = () => {
				switch (this.props.icon) {
					case 'mail':
						return (
							<MailIcon />
						)
					case 'google':
						return (
							<GoogleIcon />
						)
					case 'office':
						return (
							<OfficeIcon />
						)
				}
			}
		}

		return (
			<div className={styles[this.props.size]}>
				<div className={styles.innerbox}>
					<p className={styles.icon}> <Icon /> </p>
					<p className={styles.text}> {this.props.children} </p>
				</div>
			</div>
		)
	}

}

DPC_SecondaryButton.defaultProps = {
	size: 'medium',
	icon: null,
}

DPC_SecondaryButton.propTypes = {
	size: PropTypes.string,
	children: PropTypes.node,
	icon: PropTypes.string,
}

export default DPC_SecondaryButton
